module.exports = __webpack_public_path__ + "static/img/dialog.71058085.png";